import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ui-bottom-sheet-shell',
  imports: [MatButtonModule],
  templateUrl: './bottom-sheet-shell.html',
  styleUrl: './bottom-sheet-shell.scss',
})
export class BottomSheetShell {
  @Input() title = '';
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
